import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./expert.scss";
import Filter from "../../components/Expert/filter";
import LeftCard from "../../components/Expert/leftcard";
import RightCard from "../../components/Expert/rightcard";
import Favorites from "../../components/favorite/favorite_content";
import Spinner from "../../components/Spinner/spinner";
import { useNavigate } from "react-router-dom";
import useInboundSocket from "../../hooks/useInboundSocket";
import Cookies from "js-cookie";
import api from "../../api";

const Expert = ({ max, user }) => {
  const [filterStatus, setFilterStatus] = useState([]);
  const [sortStatus, setSortStatus] = useState(null);
  const [selectedExpertises, setSelectedExpertises] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const redirect = params.get("redirect");

    if (redirect) {
      window.location.href = redirect;
    } 
  }, []);
  const handleExpertiseChange = (event) => {
    const { id, checked } = event.target;
    setSelectedExpertises((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id),
    );
  };

  const handleServiceChange = (event) => {
    const { id, checked } = event.target;
    setSelectedServices((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id),
    );
  };

  const handleLanguageChange = (event) => {
    const { id, checked } = event.target;
    setSelectedLanguages((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id),
    );
  };

/*   const handleFilterChange = (filters) => {
    setFilterStatus(filters);
  }; */

  const handleFilterChange = (event) => {
  const { id, checked } = event.target;

  setFilterStatus((prev) =>
    checked
      ? [...prev, id]
      : prev.filter((item) => item !== id)
  );
};

  const handleSortChange = (sortOption) => {
    setSortStatus(sortOption);
  };

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const handleClearSelections = () => {
    setSelectedExpertises([]);
    setSelectedServices([]);
    setSelectedLanguages([]);
    setFilterStatus([]);
    setSortStatus(null);
    setSearchValue("");
  };

  const [dataExpert, setDataExpert] = useState({
    total: 0,
    data: [],
  });
  const buildIndicators = (experts) => {
    const indicators = {
      expertises: {},
      services: {},
      languages: {},
    };

    experts.forEach((expert) => {
      expert.expertises.forEach((exp) => {
        const expertise = exp.trim().toLowerCase();
        indicators.expertises[expertise] =
          (indicators.expertises[expertise] || 0) + 1;
      });

      expert.services.forEach((service) => {
        const key = service.communication;
        indicators.services[key] = (indicators.services[key] || 0) + 1;
      });

      expert.languages.forEach((lang) => {
        indicators.languages[lang] = (indicators.languages[lang] || 0) + 1;
      });
    });

    return indicators;
  };

  const [experts, setExperts] = useState([]);
  const [filteredExperts, setFilteredExperts] = useState([]);

  const fetchData = async () => {
    try {
      setShowSpinner(true);

      const response = await api.get(`/content/experts/list`);

      const data = response.data.data;

      setExperts(data);
      setFilteredExperts(data);

      setDataExpert({
        total: data.length,
        data: data,
      });
    } catch (error) {
      console.error("Error fetching experts:", error);
    } finally {
      setShowSpinner(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const indicators = buildIndicators(experts);
  const getInboundExtensions = (experts = []) => {
    const extensionsSet = new Set();

    experts.forEach((expert) => {
      expert.services?.forEach((service) => {
        if (service.call_type === "prn" || service.call_type === "credit") {
          service.extensions?.forEach((ext) => {
            if (ext.type === "inbound" && ext.data) {
              extensionsSet.add(ext.data);
            }
          });
        }
      });
    });

    return Array.from(extensionsSet);
  };
  const inboundExtensions = useMemo(
    () => getInboundExtensions(experts),
    [experts],
  );

  const inboundStatuses = useInboundSocket(inboundExtensions);

  return (
    <>
      {showSpinner ? (
        <Spinner />
      ) : (
        <div className="row m-0">
         {/*  <Filter
            onFilterChange={handleFilterChange}
            onSortChange={handleSortChange}
            onSearchChange={handleSearchChange}
            selectedExpertises={selectedExpertises}
            selectedServices={selectedServices}
            selectedLanguages={selectedLanguages}
            onExpertiseChange={handleExpertiseChange}
            onServiceChange={handleServiceChange}
            onLanguageChange={handleLanguageChange}
            onClearSelections={handleClearSelections}
            indicators={indicators}
          /> */}
          <LeftCard
            selectedExpertises={selectedExpertises}
            selectedServices={selectedServices}
            selectedLanguages={selectedLanguages}
            onExpertiseChange={handleExpertiseChange}
            onServiceChange={handleServiceChange}
            onLanguageChange={handleLanguageChange}
            onClearSelections={handleClearSelections}
            indicators={indicators}
            onSortChange={handleSortChange}
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
            filterStatus={filterStatus}
            sortStatus={sortStatus}
            searchValue={searchValue}
          />

          <RightCard
            filterStatus={filterStatus}
            selectedExpertises={selectedExpertises}
            selectedServices={selectedServices}
            selectedLanguages={selectedLanguages}
            sortStatus={sortStatus}
            searchValue={searchValue}
            cards={dataExpert.data}
            setCards={(updateFn) =>
              setDataExpert((prev) => ({
                ...prev,
                data:
                  typeof updateFn === "function"
                    ? updateFn(prev.data)
                    : updateFn,
              }))
            }
            max={max}
            user={user}
            inboundStatuses={inboundStatuses}
          />
        </div>
      )}
    </>
  );
};

export default Expert;
